const vehicles = {
  Carro: 'car',
  Moto: 'motorcycle',
  Caminhão: 'truck',
  Agregado: 'aggregate',
  Implemento: 'implement',
};

const convertToEnglish = (vehicle) => {
  return vehicles[vehicle] || vehicle;
};

export default convertToEnglish;
